import { Row, Col } from "antd";
import React, { useEffect, useState } from 'react';
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  FooterContainer,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
  ExternalLink,
  Tagline,
  BottomBar,
} from "./styles";
import { trackEvent } from "../../utils/analytics";
import { useUser } from "../../contexts/userContext";
interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };
  const { loggedInUser } = useUser();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: any) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    trackEvent("install-button-click", {
      user: loggedInUser?.cnt_id || 'unknown',
      state: 'from footer'
    });
    if (deferredPrompt) {
      // Show the install prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      const { outcome } = await deferredPrompt.userChoice;
       if (outcome === 'accepted') {
        trackEvent("install-button-accepted", {
          user: loggedInUser?.cnt_id || 'unknown',
          state: 'from footer'
        });
        console.log('User accepted the install prompt');
      } else {
        trackEvent("install-button-dismissed", {
          user: loggedInUser?.cnt_id || 'unknown',
          state: 'from footer'
        });
        console.log('User dismissed the install prompt');
      }
       setDeferredPrompt(null);
    }
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row gutter={[32, 16]}>
            <Col lg={8} md={8} sm={24} xs={24}>
              <Title>Nijulishe</Title>
              <Tagline>Know when the lights go out.</Tagline>
              <Para>Free KPLC planned outage alerts and community power reports for Kenya.</Para>
              {deferredPrompt && (
                <button onClick={handleInstallClick} style={{ height: '36px', marginTop: '1rem' }}>
                  Install PWA
                </button>
              )}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <Title>Explore</Title>
              <NavLink to="/outages/map">Outage map</NavLink>
              <NavLink to="/outages/list">Outage list</NavLink>
              <NavLink to="/areas">Areas</NavLink>
              <NavLink to="/blog/kplc-scheduled-outages">KPLC outage schedules</NavLink>
              <NavLink to="/power-tips">Power tips</NavLink>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <Title>Company</Title>
              <NavLink to="/about">About us</NavLink>
              <NavLink
                to="/support"
                onClick={() => trackEvent("contact-us-page-click", {
                  user: loggedInUser?.cnt_id || 'unknown',
                  location: 'footer'
                })}
              >
                Contact us
              </NavLink>
              <ExternalLink
                onClick={() => trackEvent("contact-button-click", {
                  user: loggedInUser?.cnt_id
                })}
                href="mailto:info@nijulishe.co.ke?bcc=nijulisheke@gmail.com"
              >
                Email us
              </ExternalLink>
              <ExternalLink href="https://chajagrid.com/" target="_blank" rel="noopener">
                ChajaGrid ↗
              </ExternalLink>
            </Col>
          </Row>
          <BottomBar>
            <span>© {new Date().getFullYear()} Nijulishe KE · Nairobi, Kenya</span>
            <span>
              A community service from the team behind{' '}
              <a href="https://chajagrid.com/" target="_blank" rel="noopener">ChajaGrid</a>
            </span>
          </BottomBar>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
